import React, { useEffect, useState } from "react";
import Layout from "../layout/Layout";
import { useDispatch, useSelector } from "react-redux";
import { totalTransactions } from "../Redux/Action/TransactionAction";
import Pagination from "../Component/Pagination";
import moment from "moment";
import { useNavigate } from "react-router-dom";

export default function Transaction() {
  const [limit] = useState(10);
  const navigate = useNavigate();
  const [page, setPage] = useState(1);
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(
      totalTransactions({
        limit,
        page,
        status: ["success", "refund", "withdraw"],
      })
    );
  }, [dispatch, limit, page]);
  //Transaction
  const list = useSelector((state) => state.Transaction.total_transaction);
  console.log(list);

  const handlePageClick = (e) => {
    setPage(e.selected + 1);
  };

  return (
    <Layout>
      {" "}
      <div class="dashboard_data_wrap">
        <div class="dashbord_cont_wrapper">
          <div className="dashboard-header-card transcationcard">
            <div className="dashboard-content">
              <div className="dashboard-metrics">
                <div
                  className="metric transcationbxc"
                  onClick={() => {
                    navigate("/transaction");
                  }}
                >
                  <div className="bxcontent">
                    <svg
                      width="54"
                      height="54"
                      viewBox="0 0 54 54"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M25.0875 41.8499H28.8563V39.2062C30.6938 38.9062 32.2125 38.1187 33.4125 36.8437C34.6125 35.5687 35.2125 34.0874 35.2125 32.3999C35.2125 30.7124 34.6969 29.2687 33.6656 28.0687C32.6344 26.8687 31.05 25.8749 28.9125 25.0874C26.625 24.2624 25.1157 23.5593 24.3844 22.978C23.6531 22.3968 23.2875 21.6374 23.2875 20.6999C23.2875 19.9499 23.6156 19.3312 24.2719 18.8437C24.9281 18.3562 25.7813 18.1124 26.8313 18.1124C27.8813 18.1124 28.8 18.3655 29.5875 18.8718C30.375 19.378 30.9 20.0624 31.1625 20.9249L34.4813 19.5187C34.0313 18.2812 33.3094 17.2405 32.3157 16.3968C31.3219 15.553 30.1688 15.0187 28.8563 14.7937V12.1499H25.1438V14.8499C23.4563 15.2249 22.1063 15.9468 21.0938 17.0155C20.0813 18.0843 19.575 19.3312 19.575 20.7562C19.575 22.4437 20.1469 23.878 21.2906 25.0593C22.4344 26.2405 24.2438 27.2624 26.7188 28.1249C28.4063 28.7249 29.6344 29.3624 30.4032 30.0374C31.1719 30.7124 31.5563 31.4999 31.5563 32.3999C31.5563 33.3749 31.1625 34.1905 30.375 34.8468C29.5875 35.503 28.6125 35.8312 27.45 35.8312C26.2125 35.8312 25.1157 35.4187 24.1594 34.5937C23.2031 33.7687 22.5563 32.6999 22.2188 31.3874L18.7313 32.8499C19.1813 34.4249 19.9688 35.7655 21.0938 36.8718C22.2188 37.978 23.55 38.7374 25.0875 39.1499V41.8499ZM27 48.5999C24.0375 48.5999 21.2438 48.0374 18.6188 46.9124C15.9938 45.7874 13.6969 44.2405 11.7281 42.2718C9.7594 40.303 8.21252 38.0062 7.08752 35.3812C5.96252 32.7562 5.40002 29.9624 5.40002 26.9999C5.40002 23.9999 5.96252 21.1968 7.08752 18.5905C8.21252 15.9843 9.7594 13.6968 11.7281 11.728C13.6969 9.75928 15.9938 8.2124 18.6188 7.0874C21.2438 5.9624 24.0375 5.3999 27 5.3999C30 5.3999 32.8032 5.9624 35.4094 7.0874C38.0157 8.2124 40.3032 9.75928 42.2719 11.728C44.2407 13.6968 45.7875 15.9843 46.9125 18.5905C48.0375 21.1968 48.6 23.9999 48.6 26.9999C48.6 29.9624 48.0375 32.7562 46.9125 35.3812C45.7875 38.0062 44.2407 40.303 42.2719 42.2718C40.3032 44.2405 38.0157 45.7874 35.4094 46.9124C32.8032 48.0374 30 48.5999 27 48.5999ZM27 44.5499C31.875 44.5499 36.0188 42.8437 39.4313 39.4312C42.8438 36.0187 44.55 31.8749 44.55 26.9999C44.55 22.1249 42.8438 17.9812 39.4313 14.5687C36.0188 11.1562 31.875 9.4499 27 9.4499C22.125 9.4499 17.9813 11.1562 14.5688 14.5687C11.1563 17.9812 9.45002 22.1249 9.45002 26.9999C9.45002 31.8749 11.1563 36.0187 14.5688 39.4312C17.9813 42.8437 22.125 44.5499 27 44.5499Z"
                        fill="#17C470"
                      />
                    </svg>
                    <div className="bcxcontent">
                      <h4>{list?.total}</h4>
                      <small>Total transaction</small>
                    </div>
                  </div>
                </div>

                <div
                  className="metric transcationbxc"
                  onClick={() => {
                    navigate("/withdraw");
                  }}
                >
                  <div className="bxcontent">
                    <svg
                      width="54"
                      height="54"
                      viewBox="0 0 54 54"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M24.75 49.3873C21.9 49.0873 19.2469 48.3092 16.7906 47.0529C14.3344 45.7967 12.1969 44.1654 10.3781 42.1592C8.55937 40.1529 7.125 37.8561 6.075 35.2686C5.025 32.6811 4.5 29.9248 4.5 26.9998C4.5 23.5873 5.18437 20.4373 6.55312 17.5498C7.92188 14.6623 9.7875 12.1873 12.15 10.1248H6.75V5.6248H20.25V19.1248H15.75V12.9936C13.6875 14.6436 12.0469 16.6779 10.8281 19.0967C9.60938 21.5154 9 24.1498 9 26.9998C9 31.6123 10.5094 35.5967 13.5281 38.9529C16.5469 42.3092 20.2875 44.2686 24.75 44.8311V49.3873ZM23.7937 37.3498L14.2875 27.7873L17.4375 24.6373L23.7937 30.9936L36.5625 18.2248L39.7125 21.4311L23.7937 37.3498ZM33.75 48.3748V34.8748H38.25V41.0061C40.3125 39.3186 41.9531 37.2748 43.1719 34.8748C44.3906 32.4748 45 29.8498 45 26.9998C45 22.3873 43.4906 18.4029 40.4719 15.0467C37.4531 11.6904 33.7125 9.73105 29.25 9.16855V4.6123C34.95 5.1748 39.75 7.5748 43.65 11.8123C47.55 16.0498 49.5 21.1123 49.5 26.9998C49.5 30.4123 48.8156 33.5623 47.4469 36.4498C46.0781 39.3373 44.2125 41.8123 41.85 43.8748H47.25V48.3748H33.75Z"
                        fill="#FFC600"
                      />
                    </svg>
                    <div className="bcxcontent">
                      <p>
                        Withdrawal <br />
                        transaction
                      </p>
                    </div>
                  </div>
                </div>

                <div
                  className="metric transcationbxc"
                  onClick={() => {
                    navigate("/admin-transaction");
                  }}
                >
                  <div className="bxcontent">
                    <svg
                      width="54"
                      height="54"
                      viewBox="0 0 54 54"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M27 49.5C23.8875 49.5 20.9625 48.9094 18.225 47.7281C15.4875 46.5469 13.1062 44.9438 11.0812 42.9188C9.05625 40.8937 7.45312 38.5125 6.27187 35.775C5.09062 33.0375 4.5 30.1125 4.5 27C4.5 23.8875 5.09062 20.9625 6.27187 18.225C7.45312 15.4875 9.05625 13.1062 11.0812 11.0812C13.1062 9.05625 15.4875 7.45312 18.225 6.27187C20.9625 5.09062 23.8875 4.5 27 4.5C29.4375 4.5 31.7437 4.85625 33.9187 5.56875C36.0937 6.28125 38.1 7.275 39.9375 8.55L36.675 11.8687C35.25 10.9687 33.7312 10.2656 32.1187 9.75938C30.5063 9.25313 28.8 9 27 9C22.0125 9 17.7656 10.7531 14.2594 14.2594C10.7531 17.7656 9 22.0125 9 27C9 31.9875 10.7531 36.2344 14.2594 39.7406C17.7656 43.2469 22.0125 45 27 45C31.9875 45 36.2344 43.2469 39.7406 39.7406C43.2469 36.2344 45 31.9875 45 27C45 26.325 44.9625 25.65 44.8875 24.975C44.8125 24.3 44.7 23.6438 44.55 23.0063L48.2062 19.35C48.6187 20.55 48.9375 21.7875 49.1625 23.0625C49.3875 24.3375 49.5 25.65 49.5 27C49.5 30.1125 48.9094 33.0375 47.7281 35.775C46.5469 38.5125 44.9438 40.8937 42.9188 42.9188C40.8937 44.9438 38.5125 46.5469 35.775 47.7281C33.0375 48.9094 30.1125 49.5 27 49.5ZM23.85 37.35L14.2875 27.7875L17.4375 24.6375L23.85 31.05L46.35 8.49375L49.5 11.6437L23.85 37.35Z"
                        fill="#17C470"
                      />
                    </svg>
                    <div className="bcxcontent">
                      <p>
                        Admin <br />
                        Transactions
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="user_list_wrap">
            <table class="table table-stripd responsive-table">
              <thead>
                <th> Transactions ID </th>
                <th>Date</th>
                <th>Amount</th>
                <th>Status</th>
              </thead>
              <tbody>
                {list?.transaction?.map(function (object, i) {
                  return (
                    <tr>
                      <td data-label="Transaction ID">{object?._id}</td>
                      <td data-label="Date">{moment(object?.createdAt).format("DD-MM-YYYY")}</td>
                      <td data-label="Amount">
                        {object?.amount?.toLocaleString("en-US", {
                          style: "currency",
                          currency: "USD",
                        })}
                      </td>
                      <td data-label="Status">
                        {object?.status === "success" ? (
                          <div className="active_button">Complete</div>
                        ) : (
                          <div className="active_button-block">Refund</div>
                        )}
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
          <Pagination
            handlePageClick={handlePageClick}
            pageCount={Math.ceil((list?.count || 0) / limit)}
          />
        </div>
      </div>
    </Layout>
  );
}
